/* eslint-disable no-unused-vars */
import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    user: null, // profilo utente { username, role, assigned_properties, ... }
    activeProperty: null, // codice proprietà attiva (es. 'FSH')
    data: null, // { access, refresh }
    isAuth: false,
    mfaRequired: false,
    preToken: null,
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        loginStep1Success: (state, action) => {
            state.mfaRequired = true;
            state.preToken = action.payload.pre_token;
        },
        loginSuccess: (state, action) => {
            state.isAuth = true;
            state.user = action.payload.user;
            state.activeProperty = action.payload.active_property;
            state.data = {
                access: action.payload.access,
                refresh: action.payload.refresh,
            };
            state.mfaRequired = false;
            state.preToken = null;
        },
        logout: (state) => {
            Object.assign(state, initialState);
        },
        resetLoginFlow: state => {
            state.mfaRequired = false;
            state.preToken = null;
        },
        updateUserProfile: (state, action) => {
            if (state.user) {
                // Se stiamo aggiornando il profilo innestato
                if (action.payload.profile) {
                    state.user.profile = {
                        ...state.user.profile,
                        ...action.payload.profile
                    };
                }
                // Altrimenti aggiorna le proprietà di primo livello
                else {
                    state.user = { 
                        ...state.user, 
                        ...action.payload 
                    };
                }
            }
        },
        updateAccessToken: (state, action) => {
            if (state.data) {
                state.data.access = action.payload.access;
                // Aggiorna il refresh token solo se fornito nella risposta
                if (action.payload.refresh) {
                    state.data.refresh = action.payload.refresh;
                }
            }
        },
        setActivePropertyCode: (state, action) => {
            state.activeProperty = action.payload;
        },
    },
    extraReducers: (builder) => {
        // logica extraReducers per login, etc.
    },
});

export const selectUser = state => state.user;

export const logout = (redirectTo) => {
    return (dispatch) => {
        localStorage.clear();
        dispatch(logoutSuccess());
        if (redirectTo) {
            redirectTo("/");
        }
    };
};

export const {
    loginStep1Success,
    loginSuccess,
    logout:logoutAction,
    resetLoginFlow,
    updateUserProfile,
    updateAccessToken,
    setActivePropertyCode,
} = userSlice.actions;

export default userSlice.reducer;
